import { createFileRoute } from '@tanstack/react-router'
import { TermsOfUsePage } from '@/pages/TermsOfUsePage'
import { ROUTES } from '@/constants/routeConstants.ts'

const TermsOfUse = () => {
  return <TermsOfUsePage />
}

export const Route = createFileRoute(ROUTES.TERMS_OF_USE)({
  component: TermsOfUse,
})
